// @flow
import listWithBullets from './listWithBullets';
import type { RequestGeneratorClient } from './types';
import listInSeries from './listInSeries';

const hasRequestStatus = ({ cpaAdjustment, trialBalanceOrPriorReturn }) =>
  cpaAdjustment === 'DATA_REQUESTED' || trialBalanceOrPriorReturn === 'DATA_REQUESTED';

const getYearsDataIsRequestedFor = yearlyData =>
  yearlyData
    .filter(hasRequestStatus)
    // We need documents for the year prior to the one we're working on
    .map(({ year }) => year - 1)
    .sort();

const getYearlyDataRequests = yearlyData =>
  yearlyData
    .sort((a, b) => a.year - b.year)
    .reduce((requests, { cpaAdjustment, trialBalanceOrPriorReturn, year }, index) => {
      // We need documents for the year prior to the one we're working on
      const yearDataIsRequestedFor = year - 1;
      if (trialBalanceOrPriorReturn === 'DATA_REQUESTED') {
        const earliestYear = index === 0;
        if (earliestYear) {
          requests.push(`Your ${yearDataIsRequestedFor} business tax return or trial balance`);
        } else {
          requests.push(`Your ${yearDataIsRequestedFor} business tax return`);
        }
      }
      if (cpaAdjustment === 'DATA_REQUESTED') {
        requests.push(
          `Any adjusting journal entries your CPA may have made to your ${yearDataIsRequestedFor} year-end financial statements`,
        );
      }
      return requests;
    }, []);

const requestYearlyData = ({ yearlyData }: RequestGeneratorClient): string => {
  const yearsWithRequests = getYearsDataIsRequestedFor(yearlyData);
  if (yearsWithRequests.length === 0) {
    return '';
  }
  const yearlyDataRequests = getYearlyDataRequests(yearlyData);
  const years = listInSeries(yearsWithRequests);
  return `\
To ensure our bookkeeping matches your ${years} tax filing, we also require:
${listWithBullets(yearlyDataRequests)}\
`;
};

export default requestYearlyData;
